__webpack_require__.p = "/reports-dashboard-templates-fixes/referrals-hub/";